import { render, staticRenderFns } from "./ReportedRatings.vue?vue&type=template&id=24794b6f"
import script from "./ReportedRatings.vue?vue&type=script&lang=js"
export * from "./ReportedRatings.vue?vue&type=script&lang=js"
import style0 from "./ReportedRatings.vue?vue&type=style&index=0&id=24794b6f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports